import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import axios from 'axios';
import NewsletterSubscriber from './newsletter_subscriber';
import NewsletterSignupForm from './newsletters_form';
import withTracking from '../../../utils/tracking/components/withTracking';
import { newsletterSubmit } from '../../../utils/tracking/events/pageEvents';
import EventModel from '../../../utils/tracking/models';

class NewslettersPageForm extends NewsletterSubscriber {
  handleSubmit() {
    const savedEmail = this.state.email;
    const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const emailStatus = emailRegex.test(savedEmail);
    const captcha = this.state.recaptcha;
    let listIds = get(this.props, 'listIds', false);
    if (listIds === false) {
      listIds = [497];
    } else if (listIds === []) {
      // alert('Please choose a newsletter to subscribe to');
      return;
    }
    listIds.forEach(listId => {
      const data = {
        email: savedEmail,
        first_name: 'First Name Placeholder',
        last_name: 'Last Name Placeholder',
        double_opt_in: false,
        listId
      };

      if (emailStatus && captcha !== undefined) {
        const webApiUrl = 'https://tempo.inc.com/getrevue/add';
        const tokenStr = 'iHKTPKgaDUSYFKnbsZlEnbPT119pM-3e';
        const submissionStatus = {
          success: false,
          response: null
        };

        axios
          .post(webApiUrl, data, {
            headers: {
              Authorization: `Token ${tokenStr}`
            }
          })
          .then(response => {
            if (response.status === 200) {
              submissionStatus.success = true;
              submissionStatus.response = response;

              this.setState({
                disabled: true,
                email: "You're Subscribed!"
              });
            }
          })
          .catch(err => {
            submissionStatus.response = err;

            this.setState({
              disabled: false,
              status: err.response.data.error.email[0]
            });
          })
          .then(() => {
            /* Always run after newsletter form submission */
            // Create tracking event object
            const submitEvent = new EventModel(
              'newsletter signup page',
              'newsletter signups',
              'submit',
              submissionStatus.success
                ? 'signup'
                : get(
                    submissionStatus,
                    'response.response.data.error.email',
                    'ERROR'
                  ),
              'signup-page'
            );

            // Add custom data to tracking event object
            submitEvent.addTrackingAttributes({
              componentName: 'Newsletter-Signup-Page',
              componentCategory: 'newsletter signups',
              error: submissionStatus.success
                ? 'success'
                : get(
                    submissionStatus,
                    'response.response.data.error.email',
                    'Unknown Error'
                  ),
              submissionStatus,
              provider: ['compass'],
              pageUrl: get(
                window,
                'location.href',
                'https://www.fastcompany.com/unknown-signup-url'
              )
            });
            // Track Newsletter signup attempt
            // this.props.trackClick(submitEvent.getTrackingObject());
            if (submissionStatus.success) {
              // Track successful newsletter signup
              this.props.trackNewsletterSubmission(
                submitEvent.getTrackingObject()
              );
            }
          });
      } else {
        this.setState({ disabled: false, status: 'Please Try Again' });
      }
    });
  }

  render() {
    const formParams = {
      handleEmailUpdate: this.handleEmailUpdate,
      emailValue: this.state.email,
      handleSignupSubmit: this.handleSubmit,
      disabled: this.state.disabled,
      buttonText: this.state.disabled ? 'Latest stories' : 'Sign Up',
      placeholder:
        get(this.statusMessages, [this.state.status]) || 'YOUR EMAIL ADDRESS',
      listsDictionary: this.props.listsDictionary,
      sections: this.props.sections,
      state: this.state.newsletters,
      filter: false,
      status: this.state.status,
      transition: false,
      handleNewslettersUpdate: this.handleUpdate,
      hed: this.props.hed,
      dek: this.props.dek,
      handleVerify: this.handleVerify,
      reCaptchaPublic: this.props.config.reCaptcha
    };
    return <NewsletterSignupForm {...formParams} />;
  }
}

NewslettersPageForm.propTypes = {
  listsDictionary: PropTypes.shape({}).isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

const mapTrackingToProps = trackEvent => ({
  trackNewsletterSubmission: pageObject =>
    trackEvent(newsletterSubmit(pageObject))
  // trackClick: pageObject => trackEvent(defaultClick(pageObject))
});

const trackedNewslettersPageForm = withTracking(mapTrackingToProps)(
  NewslettersPageForm
);

export default trackedNewslettersPageForm;
